import { __awaiter } from "tslib";
import { createGuid } from '@office-start/guid-generator';
import { StoreAppId } from '../constants';
import { logTaskModuleDialogDebugEvent } from './logTaskModuleDialogDebugEvent';
/**
 * gets props for loading store app in task module dialog
 * @param appId Id of the app
 * @param dialogInfo task module dialog info/ task info
 * @returns Promise<ShowTaskModuleProps | undefined>
 */
export const getStoreDialogProps = (dialogInfo, dialogType) => __awaiter(void 0, void 0, void 0, function* () {
    const appHostSessionId = createGuid();
    return {
        appId: StoreAppId,
        appHostSessionId,
        dialogType,
        taskInfo: dialogInfo,
        submitHandler: () => {
            logTaskModuleDialogDebugEvent(`User invoked a ${dialogType} task module dialog`);
        },
    };
});
//# sourceMappingURL=getStoreDialogProps.js.map